module.exports = __webpack_public_path__ + "static/img/theme3.bb7f2840.png";